import * as React from 'react'
import { toast } from 'react-toastify'
import { adminService } from '../../../../../services'
import Segment from 'semantic-ui-react/dist/commonjs/elements/Segment/Segment'
import { Button, Input } from 'semantic-ui-react'
import { InputOnChangeData } from 'semantic-ui-react/dist/commonjs/elements/Input/Input'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { HistoryRollRequest } from './HistoryRollRequest'
import { common } from '../../../../../utils/common'

type AdminRollState = {
  isLoading: boolean,
  rollRequestId?: number,
  showPopup: boolean,
  rollRequest?: IRollRequest,
}

export default class AdminRoll extends React.Component {
  state: AdminRollState = {
    isLoading: false,
    showPopup: false,
  }

  onClickRollButton = () => {
    const {rollRequestId} = this.state
    if (!rollRequestId) {
      toast.error('Bạn chưa nhập roll request id!')
      return
    }
    adminService.getRollRequest(rollRequestId)
      .then(rollRequest => this.setState({
        rollRequest: rollRequest,
        showPopup: true
      }))
      .catch(error => toast.error(error.message))
  }

  onClickConfirmButton = () => {
    const {rollRequest} = this.state
    if (rollRequest) {
      this.setState({isLoading: true})
      adminService.doRollRequest(rollRequest)
        .then(rollResult => {
          if (rollResult.success) {
            toast.success('Roll thành công!')
          } else {
            toast.warn('Roll không thành công! Thông tin: ' + rollResult.message)
          }
          this.refreshState()
        })
        .catch(error => {
          toast.error(error.message)
          this.refreshState()
        })
    }
  }

  onChangeRollRequestId = (event: React.SyntheticEvent<HTMLInputElement>, data: InputOnChangeData) => {
    this.setState({
      rollRequestId: data.value
    })
  }

  toggle() {
    const { showPopup } = this.state
    this.setState({
      showPopup: !showPopup
    })
  }

  refreshState = () => {
    this.setState({
      isLoading: false,
      rollRequestId: undefined,
      showPopup: false,
      rollRequest: undefined,
    })
  }

  render() {
    const {isLoading, showPopup, rollRequestId, rollRequest} = this.state
    return (
      <div>
        <Segment loading={isLoading}>
          <Input value={rollRequestId} label={'Roll request ID'} onChange={this.onChangeRollRequestId}/>
          <Button color={'blue'} onClick={this.onClickRollButton}> ROLL </Button>
        </Segment>
        <HistoryRollRequest/>
        <Modal isOpen={showPopup} toggle={this.toggle}>
          <ModalHeader>Xác nhận</ModalHeader>
          <ModalBody>
            {rollRequest &&
              <div>
                Bạn có đồng ý roll cho request:
                <br/>id: {rollRequest.id}
                <br/>Tổng Value: {rollRequest.totalValue}
                <br/>Tổng Vnđ: {rollRequest.totalVnd}
                <br/>
                Phí nạp tiền: {rollRequest.feeFactor ? `${(rollRequest.feeFactor * 100).toLocaleString('vn')} %` : '0'}
                <br/>
                Tổng vnđ + phí: {common.calculateFee(rollRequest.totalVnd, rollRequest.feeFactor).toLocaleString('vn')}
                <br/>Steam ID: {rollRequest.steamId}
                <br/><strong>STATUS: {rollRequest.status}</strong>
              </div>
            }
          </ModalBody>
          <ModalFooter>
            {rollRequest && rollRequest.status === 'PENDING' &&
            <Button color={'green'} onClick={this.onClickConfirmButton}>CÓ</Button>
            }
            <Button color={'red'} onClick={() => this.setState({showPopup: false})}>KHÔNG</Button>
          </ModalFooter>
        </Modal>
      </div>)
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/HomeRoll/modules/Admin/containers/AdminRoll.tsx